import { render, staticRenderFns } from "./MastitisGoals.vue?vue&type=template&id=6c3d22b1&"
import script from "./MastitisGoals.vue?vue&type=script&lang=js&"
export * from "./MastitisGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports